import { css } from 'aphrodite';
import { withAuthenticationRequired } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
import { Button, Header } from 'semantic-ui-react';

import {
    USERS_VIEW_REQUIRED_PERMISSION,
    USERS_WRITE_REQUIRED_PERMISSION,
} from '../../../application/security/permissions';
import PermissionAwareSubmitButton from '../../common/button/PermissionAwareSubmitButton';
import { DefaultLayout } from '../../layout/DefaultLayout';
import stylesCommons from '../../StylesCommons';
import { triggerChangedUsersSync } from '../actions';

import UserTable from './UserTable';

function UserList() {
    const navigation = useNavigate();

    return (
        <DefaultLayout requiredPermission={USERS_VIEW_REQUIRED_PERMISSION}>
            <div className={css(stylesCommons.content)}>
                <Header as={'h2'}>{'Existing users'}</Header>
                <div>
                    <Button
                        className={css(stylesCommons.buttonPrimary)}
                        onClick={() => navigation('/users/create')}>
                        {'Create new user'}
                    </Button>
                    <PermissionAwareSubmitButton
                        requiredPermission={USERS_WRITE_REQUIRED_PERMISSION}
                        buttonText={'Import Users'}
                        onClick={triggerChangedUsersSync}
                    />
                </div>
                <UserTable />
            </div>
        </DefaultLayout>
    );
}

export default withAuthenticationRequired(UserList, {
    OnRedirecting: () => <div>Redirecting to the login page...</div>,
});
